import React from 'react';
import {
  FacebookShareButton,
  FacebookIcon,
  WhatsappIcon,
  WhatsappShareButton,
  EmailIcon,
  EmailShareButton,
  TwitterIcon,
  TwitterShareButton,
} from 'react-share';
import styled from 'styled-components';

const Container = styled('div')`
  display: flex;
  align-items: center;
`;
const ListContainer = styled('ul')`
  display: flex;
  list-style: none;
  align-items: center;
`;
const ListItem = styled('li')`
  &:not(:first-child) {
    margin-left: 5px;
  }
`;

type TProps = {
  title: string;
  link: string;
};

const ShareListing = ({ link, title }: TProps) => {
  return (
    <Container>
      <strong>Share:</strong>
      <ListContainer>
        <ListItem className="tg-facebook">
          <FacebookShareButton quote={title} url={link}>
            <FacebookIcon size={32} round />
          </FacebookShareButton>
        </ListItem>
        <ListItem className="tg-facebook">
          <WhatsappShareButton url={link}>
            <WhatsappIcon size={32} round />
          </WhatsappShareButton>
        </ListItem>
        <ListItem className="tg-facebook">
          <EmailShareButton url={link}>
            <EmailIcon size={32} round />
          </EmailShareButton>
        </ListItem>
        <ListItem className="tg-facebook">
          <TwitterShareButton url={link}>
            <TwitterIcon size={32} round />
          </TwitterShareButton>
        </ListItem>
      </ListContainer>
    </Container>
  );
};

export default ShareListing;
